import React, { Component } from 'react';
import classes from './App.css';
import { BrowserRouter, Route } from 'react-router-dom';
import Planning from '../../containers/Planning/Planning';
import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';
import PlanOutput from '../../containers/PlanOutput/PlanOutput';
import SimpleReportBuilder from '../../containers/SimpleReportBuilder/SimpleReportBuilder';
import CalculatorNotes from '../../components/CalculatorNotes/CalculatorNotes';
import Disclaimer from '../../components/Disclaimer/Disclaimer';
import inStream from '../../components/inStream/inStream';
import Methodology from '../../components/Methodology/Methodology';
import AdminLoginPage from '../Admin/AdminLoginPage/AdminLoginPage';
import AdminRatesPage from '../Admin/AdminRatesPage/AdminRatesPage';
import AdminProductsPage from '../Admin/AdminProductsPage/AdminProductsPage';
import Introduction from '../Introduction/Introduction';
import axios from 'axios';
import { connect } from 'react-redux';
import Config from 'Config';
import LoadingModal from '../LoadingModal/LoadingModal';
import ErrorMsg from '../ErrorMsg/ErrorMsg';
import Glossary from '../../components/Glossary/Glossary';
import Start from '../../containers/Start/start';
import RaymondJames from '../../containers/Start/RaymondJames';
import WellsFargo from '../../containers/Start/WellsFargo';
import ErrorPage from '../../containers/ErrorPage/ErrorPage';
import AdminAuth from '../../services/AdminAuth';
import Mmfa from "../Start/Mmfa";
import Ria from "../Start/Ria";

const ADDITIONAL_INFO = {
    "RAYMOND_JAMES": "(Not for Client Use)",
    "WELLS_FARGO": "(Not for Client Use)",
    "MMFA": "(Not for Client Use)"
};

export class App extends Component {

    componentWillMount() {
        // let now = new Date();
        // axios.get(Config.serverUrl + '/j_spring_security_logout?timestamp=' + now.getTime().toString());
    }

    render() {

        let additionalInfoMessage = "";

        if (ADDITIONAL_INFO.hasOwnProperty(this.props.companyName)) {
            additionalInfoMessage = ADDITIONAL_INFO[this.props.companyName];
        }

        if (this.props.adminPage) {
            additionalInfoMessage = "(Not for Client Use)"
        }

        let productCount = 0;
        for (let product of this.props.productReducer.productsData) {
            if (this.props.companyName === "RAYMOND_JAMES") {
                if(product.userGroupRJ) productCount++;
            } else if (this.props.companyName === "MMFA") {
                if(product.userGroupMmfa) productCount++;
            } else if (this.props.companyName === "WELLS_FARGO") {
                if(product.userGroupWellsFargo) productCount++;
            }else {
                if(product.userGroupGaig) productCount++;
            }
        }

        return (
            <BrowserRouter>
                <div className={classes.App}>
                    <Header
                        additionalInfo={additionalInfoMessage}
                        isAdminAuthenticated={AdminAuth.isAdminAuthenticated()}
                        logout={this.logout}
                    />
                    <Navigation
                        showRegistration={this.props.menuOptions.showRegistration}
                        showInstream={this.props.menuOptions.showInstream}
                        showPlanCompare={this.props.menuOptions.showPlanCompare}
                        showPlanInformation={this.props.menuOptions.showPlanInformation}
                        showExplaination={this.props.menuOptions.showExplaination}
                        showDisclaimer={this.props.menuOptions.showDisclaimer}
                        showMethodology={this.props.menuOptions.showMethodology}
                        showGlossary={this.props.menuOptions.showGlossary}
                        showRates={this.props.menuOptions.showRates}
                        showProducts={this.props.menuOptions.showProducts}
                        showIntroduction={this.props.menuOptions.showIntroduction}
                        showBackToIntroductionButton={this.props.menuOptions.showBackToIntroductionButton && productCount > 1}
                    />

                    <div className={classes.container}>

                        <Route
                            exact
                            path="/"
                            component={ErrorPage}
                        />

                        <Route
                            path="/start"
                            component={Start}
                        />

                        <Route
                            path="/raymondjames"
                            component={RaymondJames}
                        />

                        <Route
                            path="/mmfa"
                            component={Mmfa}
                        />

                        <Route
                            path="/wellsfargo"
                            component={WellsFargo}
                        />

                        <Route
                            path="/ria"
                            component={Ria}
                        />

                        <Route
                            path="/annuityCalculator"
                            component={Planning}
                        />

                        <Route
                            path="/planOutput"
                            component={PlanOutput}
                        />

                        <Route
                            path="/reportBuilder"
                            component={SimpleReportBuilder}
                        />

                        <Route
                            path="/calculatorNotes"
                            component={CalculatorNotes}
                        />

                        <Route
                            path="/disclaimer"
                            render={(props) => <Disclaimer {...props} indexProtector={this.props.indexProtector} />}
                        />

                        <Route
                            path="/inStream"
                            component={inStream}
                        />

                        <Route
                            path="/methodology"
                            render={(props) => <Methodology {...props}
                                indexProtector={this.props.indexProtector}
                                productReducer={this.props.productReducer}
                            />}
                        />

                        <Route
                            path="/glossary"
                            render={(props) => <Glossary {...props} indexProtector={this.props.indexProtector} />}
                        />

                        <Route
                            exact
                            path="/admin"
                            component={AdminLoginPage}
                        />

                        <Route
                            exact
                            path="/admin/rates"
                            component={AdminRatesPage}
                        />

                        <Route
                            exact
                            path="/admin/products"
                            component={AdminProductsPage}
                        />

                        <Route
                            path="/introduction"
                            component={Introduction}
                        />

                    </div>
                    <LoadingModal />
                    <ErrorMsg />
                </div>
            </BrowserRouter>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        menuOptions: state.menuState,
        companyName: state.globalState.companyName,
        adminPage: state.admin.adminPage,
        indexProtector: state.globalState.indexProtector,
        productReducer: state.productReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js